import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    ChangeDetectorRef,
} from '@angular/core';

@Component({
    selector: 'solis-content-preload',
    templateUrl: './content-preload.component.html',
    styleUrls: ['./content-preload.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class ContentPreloadComponent implements OnInit {
    isTakingTooLong: boolean;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.isTakingTooLong = false;
        this.aLongWaiting();
    }

    aLongWaiting() {
        setTimeout(() => {
            this.isTakingTooLong = true;
            this.cdr.markForCheck();
        }, 10000);
    }
}
